"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = BackgroundImage;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _gatsbyPluginImage = require("gatsby-plugin-image");
// Packages

// Main Component
function BackgroundImage(props) {
  return /*#__PURE__*/_react.default.createElement(_gatsbyPluginImage.GatsbyImage, {
    image: props.backgroundImage,
    className: props.className || "background",
    style: {
      position: "absolute",
      zIndex: "-10",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      width: "100%",
      height: "100%",
      filter: `brightness(${props.brightness})`
    },
    objectPosition: props.objectPosition,
    alt: props.alt || ""
  });
}

// Prop Types
BackgroundImage.propTypes = {
  /**
   * Sets brightness of image
   */
  brightness: _propTypes.default.string,
  /**
   * Sets object position of image
   */
  objectPosition: _propTypes.default.string,
  /**
   * Object containing fluid properties of image (gatsby image)
   */
  backgroundImage: _propTypes.default.shape().isRequired,
  /** Additional class name(s) */
  className: _propTypes.default.string,
  /** Alt text */
  alt: _propTypes.default.string
};
BackgroundImage.defaultProps = {
  objectPosition: "50% 50%"
};
BackgroundImage.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BackgroundImage",
  "props": {
    "objectPosition": {
      "defaultValue": {
        "value": "\"50% 50%\"",
        "computed": false
      },
      "description": "Sets object position of image",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "brightness": {
      "description": "Sets brightness of image",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "backgroundImage": {
      "description": "Object containing fluid properties of image (gatsby image)",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": true
    },
    "className": {
      "description": "Additional class name(s)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "alt": {
      "description": "Alt text",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};